export default __webpack_public_path__ + "static/media/JourneyMapLandscap.162199fa.png";